import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Zap, Globe, Settings, Server, Activity, LayoutDashboard, LogOut, Database } from 'lucide-react';
import type { Theme } from './ThemeToggle';
import { ThemeToggle } from './ThemeToggle';

export default function AppLayout({
  theme,
  setTheme,
  serversCount,
  appsCount,
  missingPwLabels,
  serversConfigured,
  onOpenConfig,
  onLogout,
}: {
  theme: Theme;
  setTheme: (t: Theme) => void;
  serversCount: number;
  appsCount: number;
  missingPwLabels: string[];
  serversConfigured: boolean;
  onOpenConfig: () => void;
  onLogout: () => void;
}) {
  const missingPw = missingPwLabels.length;

  return (
    <div className="dns-page dash-page app-root-layout">
      <header className="dns-header dash-nav-header">
        <div className="dns-header-inner dash-nav-inner">
          <div className="dns-brand dash-brand">
            <div className="brand-icon">
              <Zap size={20} />
            </div>
            <div>
              <h1>MapNexa</h1>
              <p>
                {serversCount} servers · {appsCount} apps
              </p>
            </div>
          </div>
          <nav className="dash-nav" aria-label="Primary">
            <NavLink
              to="/"
              end
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="Overview"
            >
              <LayoutDashboard size={13} /> Dashboard
            </NavLink>
            <NavLink
              to="/deploy"
              end
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="Applications and deployments"
            >
              <Zap size={13} /> Deploy
            </NavLink>
            <NavLink
              to="/servers"
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="Metrics, logs, diagnostics, and maintenance"
            >
              <Server size={13} /> Servers
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="systemctl services catalog"
            >
              <Activity size={13} /> Services
            </NavLink>
            <NavLink
              to="/database"
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="PostgreSQL databases, roles, publications and subscriptions"
            >
              <Database size={13} /> Database
            </NavLink>
            <NavLink
              to="/dns"
              className={({ isActive }) => `dash-nav-link${isActive ? ' active' : ''}`}
              title="BIND zones and named.conf.local"
            >
              <Globe size={13} /> DNS
            </NavLink>
            <button
              type="button"
              className="btn btn-ghost btn-sm dash-nav-btn"
              title="Servers, apps & credentials"
              onClick={onOpenConfig}
            >
              <Settings size={13} /> Config
              {missingPw > 0 ? (
                <span className="cfg-hbadge warn" title={`Missing passwords: ${missingPwLabels.join(', ')}`}>
                  {missingPw}
                </span>
              ) : (
                serversConfigured && <span className="cfg-hbadge ok" title="All passwords entered" />
              )}
            </button>
            <button
              type="button"
              className="btn btn-ghost btn-sm dash-nav-btn"
              title="Sign out"
              onClick={onLogout}
            >
              <LogOut size={13} /> Log out
            </button>
            <ThemeToggle theme={theme} setTheme={setTheme} />
          </nav>
        </div>
      </header>

      <div className="app-layout-outlet">
        <Outlet />
      </div>
    </div>
  );
}
